<template>
    <div class="main-cn">
        <div class="main-bd mg20 pro-visible">
            <el-tabs v-model="searcheModel.query_type" @tab-click="handleClick">
                <el-tab-pane label="全部客户" name="1"></el-tab-pane>
                <el-tab-pane label="我的协作客户" name="2"></el-tab-pane>
            </el-tabs>
            <el-row class="searchSection">
                <SearchForm 
                :params="searcheModel" 
                :fields="fields" 
                :cache_field="'search_order_config_' + activeName + '_' + this.$route.path" 
                @search="submitSearch" 
                @reset="resetForm" 
                :key="search_form_key">
                    <template #customButtons>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <el-button v-if="Acs('/customers/export-download-count')" type="success" size="small" @click="exportExcel" :loading="exportButtonLoading">
                            导出Excel
                        </el-button>
                    </template>
                </SearchForm>
             
            </el-row>
            <el-row class="searchSection">
                <p style="color:#85CE61;">
                    统计数据更新时间：组卷(03:00), 校网通(00:30), 校本2(04:50), 校本3(04:00)<br>
                </p>
            </el-row>
            <div class="main-bd mg20 pro-visible">
                <el-table 
                v-loading="loading"
                :data="list" 
                border 
                height="650"
                :header-cell-style="{background: '#f3faff'}"
                @sort-change="submitSearch(null, $event)"
                >
                    <el-table-column prop="customer_name" label="学校名称">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleView(scope.row)">
                                {{ scope.row.customer_name }}
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="district_names" label="所在地区"></el-table-column>
                    <el-table-column prop="products" label="已购产品"></el-table-column>
                    <el-table-column prop="zujuan_num" label="组卷总量" sortable="zujuan_num"></el-table-column>
                    <el-table-column prop="download_num" label="下载总量" sortable="download_num"></el-table-column>
                    <el-table-column prop="download_chid_num" label="下载学科数" sortable="download_chid_num"></el-table-column>
                    <el-table-column prop="download_user_num" label="下载账号总数" sortable="download_user_num"></el-table-column>
                    <el-table-column prop="active_user_num" label="活跃用户数" sortable="active_user_num" width="160">
                        <template slot="header">
                            <!-- 自定义表头 -->
                            <span>活跃用户数</span>
                            <el-tooltip class="item" effect="dark" content="活跃用户数定义：下载量≥下载总量/下载账号总数" placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.active_user_num }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="active_subject_num" label="活跃学科数" sortable="active_subject_num" width="160">
                        <template slot="header">
                            <!-- 自定义表头 -->
                            <span>活跃学科数</span>
                            <el-tooltip class="item" effect="dark" content="活跃学科数定义：下载量≥下载总量/下载学科总数" placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.active_subject_num }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="user_name" label="绑定业务员"></el-table-column>
                    <el-table-column prop="branch_name" label="所属部门"></el-table-column>
                </el-table>
                <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
            </div>
        </div>
    </div>
  </template>
  <style scoped>
  
  </style>
  <script>
  import CustomerService from "~/services/customer";
  import OrderService from "~/services/order";
  import SearchForm from "~/widgets/SearchForm.vue";
  import MyPagination from "~/widgets/MyPagination.vue";
  import Function from "~/common/functions";
  export default {
    components: {
        SearchForm,
        MyPagination
    },
  
    props: {

    },
  
    data() {
        return {
            loading: false,
            exportButtonLoading: false,
            searcheModel: {},
            // 分页信息
            linkPage: null,
            list: [],
            search_form_key: 0,
            fields: [],
            activeName: 'download-count',
        };
    },
  
    created() {
        this.resetForm();
    },
  
    methods: {
        //重置按钮
        resetForm() {
            this.searcheModel = {
                name: '',
                type: '',
                branch_id: "",
                user_id: "",
                province_id: 0,
                city_id: 0,
                district_id: 0,
                product_id: '',
                product_type: '',
                username: '',
                created_time: [],
                product_times: [],
                download_times: [],
                path: this.$route.path,
                time_status: '',
                repay_type: '',
                download_year: new Date().getFullYear().toString(),
                query_type: '1',
                down_num: '',
                subject_num: '',
            };
            this.list = [];
            const types = CustomerService.getTypes(true);
            this.fields = [
                {field: 'base', label: '基础信息筛选条件', children: [
                    {field: 'name', label: '客户名称', type: 'components', ref: 'customer', components: 'CustomerSelect', change: 'changeObjValue'},
                    {field: 'district_id', label: '所在地区', type: 'components', ref: 'district', components: 'DistrictCascader', change: 'changeDistrict'},
                    {field: 'product_type', label: '订单类型', type: 'select', list: OrderService.getOrderType()},
                    {field: 'product_id', label: '产品筛选', type: 'components', ref: 'product', components: 'Product', change: 'getValue'},
                    {field: 'branch_id', label: '所属部门', type: 'components', ref: 'branch', components: 'UserCascader', change: 'changeCascaderLast'},
                    {field: 'username', label: '业务员姓名', type: 'components', ref: 'user', components: 'UserSelect', change: 'changeObjValue'},
                    {field: 'type', label: '客户类型', type: 'select', list: Object.keys(types).map(key => ({ value: key, label: types[key] }))},
                    {field: 'repay_type', label: '回款情况', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '未回款'}, {value: 2, label: '部分回款'},{value: 3, label: '全部回款'}]},
                ]},
                {field: 'date', label: '时间筛选条件', children: [
                    {field: 'created_time', label: '录单时间', type: 'daterange'},
                    {field: 'product_times', label: '到期时间', type: 'daterange'},
                    // {field: 'download_times', label: '下载时间', type: 'daterange'},
                    {field: 'download_year', label: '下载年份', type: 'date', date_type: 'year', format:'yyyy'},
                ]},
                {field: 'other', label: '其他筛选条件', children: [
                    {field: 'time_status', label: '是否到期', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '已到期'}, {value: 2, label: '未到期'}]},
                    {field: 'down_num', label: '下载数', type: 'input'},
                    {field: 'subject_num', label: '科目数', type: 'input'},
                ]},
            ];
            this.search_form_key ++;
            this.submitSearch();
        },

        // 筛选查询
        submitSearch(params = null, sort = null) {
            this.list = [];
            if(params){
                this.searcheModel = params;
            }
            if(sort && typeof sort.order !== undefined){
                this.searcheModel['sort_name'] = sort['prop'];
                this.searcheModel['sort_by'] = sort['order'];
            }
            params = _.clone(this.searcheModel);
            params['page'] = 1;
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
        },
        
    
        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            CustomerService.getDownloadCount(params).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                if (res._meta) {
                    // 确保分页数据的数字类型转换
                    this.linkPage = {
                        ...res._meta,
                        currentPage: parseInt(res._meta.currentPage),
                        perPage: parseInt(res._meta.perPage),
                        totalCount: parseInt(res._meta.totalCount),
                        pageCount: parseInt(res._meta.pageCount)
                    };
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            let params = _.clone(this.searcheModel);
            params['perPage'] = parseInt(newSize);
            this.getList(params);
        },

        handleCurrentChange(newPage) {
            // 处理当前页码变化事件
            let params = _.clone(this.searcheModel);
            params['page'] = parseInt(newPage);
            this.getList(params);
        },

        handleView(row) {
            let path = "/customers/view?id=" + row.customer_id;
            let to = this.$router.resolve({
                path: path
            });
            window.open(to.href, '_blank');
        },

        handleClick(tab, event) {
            this.submitSearch();
        },

        // 导出Excel
        exportExcel() {
            console.log('导出Excel按钮被点击');
            this.exportButtonLoading = true;
            let params = _.clone(this.searcheModel);
            
            // 删除空值参数，和submitSearch方法保持一致
            _.each(params, (val, key) => {
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            });

            console.log('导出参数:', params);
            
            // 使用Function.exportFile方法导出
            try {
                Function.exportFile('/api/customers/export-download-count', params);
                console.log('调用Function.exportFile完成');
            } catch (error) {
                console.error('导出文件错误:', error);
            }
            
            // 延迟关闭loading状态
            setTimeout(() => {
                this.exportButtonLoading = false;
            }, 1000);
        },
    },
  };
  </script>


// WEBPACK FOOTER //
// src/views/customer/downloadCount.vue